import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_ESCAPADA_RAK_ERG_RAK } from "@/lib/itineraryHubs";

export default function EscapadaRakErgRakHubPage() {
  return <ItineraryHubPage hub={HUB_ESCAPADA_RAK_ERG_RAK} />;
}
